import { DOCUMENT } from '@angular/common';
import { AfterContentChecked, AfterViewInit, Component, ElementRef, HostBinding, HostListener, Input, OnInit, Output, ViewChild, Directive, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppComponent } from 'app/app.component';
import { AlertPopup, config, HttpLoader, path } from 'app/app.config';
import { ChatService } from 'app/components/chat-list/chat.service';
import { StaffRoomService } from 'app/components/staff-room/staff-room.service';
import { GroupService } from 'app/components/userandgroup/group/group.service';
import { DataSharingService } from 'app/shared/data-sharing.service';
import { SocketService } from 'app/socket/socket.service';
import { Subject } from 'rxjs';
import * as _ from 'underscore';

import { ELibraryService } from './e-library.service';
import { AssistBotService } from 'app/components/ai-assist/assist-bot.service';
import { ELibraryDetailsComponent } from './e-library-details/e-library-details.component';
import { ConfirmationService } from 'primeng/api';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
// import { ELibraryUploadComponent } from './e-library-details/e-library-upload/e-library-upload.component';

//@Directive()
@Component({
  selector: 'app-e-library',
  templateUrl: './e-library.component.html',
  styleUrls: ['./e-library.component.scss'],
})
export class ELibraryComponent implements OnInit, AfterViewInit, AfterContentChecked {
  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  @ViewChild('elibraryRecordList', { static: true }) private elibraryScrollContainer: ElementRef;
  @Input() activeLinkType: ElementRef;
  @Output() activeType: string;
  profileUrl = path.PROFILE_URL;
  RECORD_LIMIT: number = config.DEFAULT_RECORD_LIMIT;
  OFFSET: number = config.DEFAULT_OFFSET;
  activeUrl: any;

  viewControl = {
    changedSearchText: false,
    closeEmptyMessages: false
  }

  sortBy = 'title';
  showSearchSec = true;
  totalRowCount: number;
  totalLessionsCount: number;
  totalUserCount: number;
  search: string;
  searchInList = new Subject<any>();
  viewLibraryList = false;
  showEmptyState = true;
  showNotification = false;
  modalScrollDistance = config.DEFAULT_SCROLL_DIST;
  modalScrollThrottle = config.SCROLL_THROTTLE;
  showPaginateSpinner = false;
  listSortBy = 'updatedAt';
  getTotalLesson: number;
  getTotalUser: number;
  listOfGroups = [];
  isUserRole: number;
  welcomeWindowName: string;
  showWelcomeWindow = true;
  loggedUserDeatails: any;
  is_tour_completed = false;
  isMobileView = false;
  isSidebarOpen = false;

  elibraryList: any[] = [];
  // public elibraryList = [];
  public subscribers: any = {};
  searchSubject = new Subject<any>();
  cities = [
    { id: 1, name: 'MA, Boston' },
    { id: 2, name: 'FL, Miami' },
    { id: 3, name: 'NY, New York', disabled: true },
    { id: 4, name: 'CA, Los Angeles' },
    { id: 5, name: 'TX, Dallas' }
  ];
  constructor(
    private alert: AlertPopup,
    private httpLoader: HttpLoader,
    private socketService: SocketService,
    private dataSharing: DataSharingService,
    private chatService: ChatService,
    private staffRoomService: StaffRoomService,
    private groupService: GroupService,
    private router: Router,
    private route: ActivatedRoute,
    private appComponent: AppComponent,
    private confirmDialogService: ConfirmationDialogService,

    private elibraryService: ELibraryService, private assistBotService: AssistBotService,
    @Inject(DOCUMENT) private document: Document
    // private elibraryUploadComponent: ELibraryUploadComponent
  ) {
    this.searchInList
      .debounceTime(500)
      .subscribe(event => {
        this.search = event.target.value;
        if (!this.search) {
          return;
        }
        this.viewControl.changedSearchText = true;
        this.getElibrary(0);
      });

    this.searchSubject.debounceTime(500).subscribe(
      event => {
        this.viewControl.changedSearchText = true;
        const searchText = event.target.value;
        // console.log(searchText);
        // this.elibdetails.getFileDetailsList(searchText);
        this.searchUserList(searchText);
      }
    )

    this.groupService.emitNewGroupCreation().subscribe((group) => {
      this.elibraryList.unshift(group);
    });
  }

  ngOnInit(): void {

    this.welcomeWindow('welcome');
    this.elibraryService.currentElibrary_groupId = 0;
    this.getElibrary(0);

    this.route.url.subscribe(() => {
      this.activeUrl = this.route.snapshot.firstChild ? this.route.snapshot.firstChild.url[0].path : false;
      this.viewLibraryList = false;
      // Close sidebar on mobile when navigating
      if (this.isMobileView) {
        this.closeSidebar();
      }
    });

    var activeRoleId = JSON.parse(window.localStorage.getItem('user_role'));
    // var roleId = activeRoleId.replace(/\"/g, "");
    this.isUserRole = parseInt(activeRoleId);

    // Check initial screen size
    this.checkMobileView();
    // this.assistBotService.getClientConfig().subscribe((res:any)=>{
    //   this.assistBotService.GptConfiguration = res.filter((configlist:any)=> configlist['clientModule']==client)[0]['configuration'];

    // });
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

    this.dataSharing.getLessionCount().subscribe(response => {
      this.elibraryList.filter(x => {
        if (x.group_id === parseInt(response.group_id)) {
          x.TotalLessonCount += 1
          // console.log(x);
        }
      })

    })
  }

  customSearchFn(term: string, item) {
    // item.full_name = item.full_name.replace(',','');
    term = term.toLocaleLowerCase();
    return item.full_name.toLocaleLowerCase().indexOf(term) > -1;
  }

  SeletedLibrary(event: any) {
    this.router.navigate(['/elibraryandcourse/e-library', event['group_id']]);
  }

  ngAfterContentChecked(): void {
    if (_.isEqual(this.loggedUserDeatails, this.appComponent.userDetail)) {
      return;
    }

    if (_.isObject(this.appComponent.userDetail)) {
      this.loggedUserDeatails = this.appComponent.userDetail;
      this.is_tour_completed = !this.loggedUserDeatails.is_tour_completed
    }
  }

  onScrollDown() {

    const listLength = this.elibraryList.length;

    if (this.totalRowCount > listLength && !this.showPaginateSpinner) {
      this.OFFSET += 1;
      this.showPaginateSpinner = true;
      this.getElibrary(this.OFFSET);
    }
  }

  getElibrary(pageNo) {
    try {
      if (pageNo === 0) {
        this.OFFSET = 0;
        this.httpLoader.showLoader();
      }
      this.listSortBy = (this.sortBy === 'time') ? 'updatedAt' : 'full_name';
      const offset = this.OFFSET;
      const payLoad = {
        offset: offset,
        limit: this.RECORD_LIMIT,
        search: this.search || '',
        sort: this.sortBy,
        data_type: true
      };

      this.staffRoomService.getClassList(payLoad).subscribe(
        response => {
          this.httpLoader.hideLoader();
          if (offset === 0) {
            this.httpLoader.hideLoader();
            if (response.hasOwnProperty('result')) {
              this.elibraryList = response['result'];
            } else {
              this.elibraryList = response['chatList'];
            }

            if (!this.route.snapshot.firstChild && this.elibraryList.length > 0) {
              const firstActiveGroup = this.elibraryList.find((g: any) => g.group_active !== false) || this.elibraryList[0];
              if (firstActiveGroup && firstActiveGroup.group_id) {
                this.router.navigate(['/elibraryandcourse/e-library', firstActiveGroup.group_id]);
              }
            }

            //  if(this.elibraryList.length > 0){
            //   if(this.elibraryService.currentElibrary_groupId !=0){
            //     this.router.navigateByUrl('elibraryandcourse/e-library/'+this.elibraryService.currentElibrary_groupId);
            //   }else{
            //     this.router.navigateByUrl('elibraryandcourse/e-library/'+this.elibraryList[0].group_id);
            //   }

            //  }
            // this.dataSharing.emitElibaryDashboardCount(this.elibraryList);
          } else if (offset > 0) {
            this.showPaginateSpinner = false;
            if (response.hasOwnProperty('result')) {
              this.elibraryList = this.elibraryList.concat(response['result']);
            } else {
              this.elibraryList = this.elibraryList.concat(response['chatList']);
            }

          }
          this.totalRowCount = response['TotalRowCount'];
        },
        (error) => {
          this.alert.showAlertMessage(error.error);
          this.showPaginateSpinner = false;
          this.httpLoader.hideLoader();
        }
      )
    } catch (err) {
      this.httpLoader.hideLoader();
    }
  }

  /** Active Teacher help Desk */
  welcomeWindow(name) {

    if (name) {
      this.showWelcomeWindow = true;
      this.welcomeWindowName = name;
    } else {
      this.showWelcomeWindow = false;
    }
  }

  showOnboarding() {
    //this.hintService.initialize({ elementsDisabled: true });
    this.showWelcomeWindow = false;
  }

  searchUserList(searchUser) {
    // this.getAllChatList(searchUser);
  }

  scrollToTop() {

  }

  fetchElibraryList() {

  }

  closedEmptyClassMsg() {
    this.viewControl.closeEmptyMessages = true;
    this.document.getElementsByClassName('second-level-menu')[0].classList.add('hide');
  }



  // showSearchbox(){
  //   this.showSearchSec = !this.showSearchSec;
  // }

  showSearchBox(toggle) {
    this.showSearchSec = !this.showSearchSec;
    if (this.viewControl.changedSearchText) {
      try {
        this.search = '';
        this.viewControl.changedSearchText = false;
        const offset = 0;
        this.getElibrary(offset);
      } catch (error) {
        this.httpLoader.hideLoader();
      }
    }
  }

  editLibrary() {
    this.elibraryService.elibraryBS.next({ "action": "showeditlibrary" });
  }

  deleteLibrary() {

  }


  ngDestory() {
    this.elibraryService.currentElibrary_groupId = 0;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkMobileView();
  }

  checkMobileView() {
    const width = window.innerWidth;
    this.isMobileView = width <= 945;
    if (!this.isMobileView && this.isSidebarOpen) {
      this.closeSidebar();
    }
    // Ensure document list is visible on tablet/small desktop
    if (width > 945 && width <= 1024) {
      // Force sidebar to be visible but smaller
      const sidebarElement = this.document.querySelector('.second-level-menu');
      if (sidebarElement) {
        sidebarElement.classList.remove('show');
      }
      this.document.body.style.overflow = '';
    }
  }

  toggleSidebar() {
    if (this.isMobileView) {
      this.isSidebarOpen = !this.isSidebarOpen;
      const sidebarElement = this.document.querySelector('.second-level-menu');
      if (sidebarElement) {
        if (this.isSidebarOpen) {
          sidebarElement.classList.add('show');
          // Prevent body scroll when sidebar is open
          this.document.body.style.overflow = 'hidden';
        } else {
          sidebarElement.classList.remove('show');
          this.document.body.style.overflow = '';
        }
      }
    }
  }

  closeSidebar() {
    if (this.isMobileView && this.isSidebarOpen) {
      this.isSidebarOpen = false;
      const sidebarElement = this.document.querySelector('.second-level-menu');
      if (sidebarElement) {
        sidebarElement.classList.remove('show');
      }
      this.document.body.style.overflow = '';
    }
  }

  removeGroupDetail(group: any): void {
    try {
      
      const id = group?.group_id;
      if (!id) return;

      this.confirmDialogService.openConfirmDialog('', {
        title: 'Confirmation',
        message: `Are you sure you want to delete this "${group?.full_name}" Document ?`,
        btnOkText: 'YES',
        btnCancelText: 'NO',
        onClose: (confirmed: boolean) => {
          if (confirmed) {
            this.httpLoader.showLoader();

            const index = _.findIndex(this.elibraryList, { group_id: id });

            if (index === -1) {
              this.httpLoader.hideLoader();
              this.alert.showAlertMessage('Document not found.');
              return;
            }

            this.groupService.deleteSelectedGroup(id).subscribe({
              next: (response) => {
                this.httpLoader.hideLoader();
                this.elibraryList.splice(index, 1);
                this.router.navigate(['/elibraryandcourse/e-library']);
              },
              error: (error) => {
                this.httpLoader.hideLoader();
                this.alert.showAlertMessage(error.error || 'Error deleting document.');
              }
            });
          }
        }
      });
    } catch (err) {
      this.httpLoader.hideLoader();
      console.error('Error in removeGroupDetail:', err);
    }
  }


  onSidebarOverlayClick() {
    this.closeSidebar();
  }
}
